/**
 * Tag repository — centralized row mapping and query helpers.
 *
 * All TagRow → LocalTag conversions go through rowToLocalTag().
 * Never define row mappers for tags elsewhere in the codebase.
 */

import type { SyncStatus } from '../../types'
import type { LocalTag } from '../db'
import type { TagRow } from './types'

export { type TagRow } from './types'

/**
 * Maps a SQLite TagRow (snake_case) to a LocalTag (camelCase).
 */
export function rowToLocalTag(row: TagRow): LocalTag {
  return {
    id: row.id,
    userId: row.user_id,
    name: row.name,
    parentId: row.parent_id ?? undefined,
    color: row.color,
    icon: row.icon,
    isPinned: Boolean(row.is_pinned),
    createdAt: row.created_at,
    syncStatus: row.sync_status as SyncStatus,
  }
}
